/* KOPRESS — Global JS */
(function () {
  'use strict';

  /* ── FAQ ACCORDION ─────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('.faq-q');
    if (!q) return;
    var item = q.closest('.faq-item');
    var isOpen = item.classList.contains('is-open');
    document.querySelectorAll('.faq-item').forEach(function (i) { i.classList.remove('is-open'); });
    if (!isOpen) item.classList.add('is-open');
  });

  /* ── MOBILE NAV ─────────────────────────────────────────────── */
  var menuBtn  = document.querySelector('.header-menu-btn');
  var mobileNav = document.querySelector('.mobile-nav');
  var closeBtn  = document.querySelector('.mobile-nav__close');
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', function () { mobileNav.classList.add('is-open'); });
    if (closeBtn) closeBtn.addEventListener('click', function () { mobileNav.classList.remove('is-open'); });
    mobileNav.addEventListener('click', function (e) {
      if (e.target === mobileNav) mobileNav.classList.remove('is-open');
    });
  }

  /* ── PRODUCT GALLERY ─────────────────────────────────────────── */
  var galleryMain = document.querySelector('.gallery-main img');
  document.querySelectorAll('.gallery-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('.gallery-thumb').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (galleryMain && thumb.dataset.src) galleryMain.src = thumb.dataset.src;
    });
  });

  /* ── SIZE GUIDE MODAL ─────────────────────────────────────────── */
  var sizeModal = document.querySelector('.size-guide-modal');
  if (sizeModal) {
    document.querySelectorAll('.size-guide-link').forEach(function (link) {
      link.addEventListener('click', function () { sizeModal.classList.add('is-open'); });
    });
    var sizeModalClose = sizeModal.querySelector('.size-guide-modal__close');
    if (sizeModalClose) sizeModalClose.addEventListener('click', function () { sizeModal.classList.remove('is-open'); });
    sizeModal.addEventListener('click', function (e) { if (e.target === sizeModal) sizeModal.classList.remove('is-open'); });
  }

  /* ── SIZE SWATCHES ────────────────────────────────────────────── */
  document.querySelectorAll('.size-swatch').forEach(function (sw) {
    sw.addEventListener('click', function () {
      sw.closest('.size-swatches').querySelectorAll('.size-swatch').forEach(function (s) { s.classList.remove('is-active'); });
      sw.classList.add('is-active');
      var label = sw.closest('.variant-block').querySelector('.selected-val');
      if (label) label.textContent = sw.textContent.trim();
    });
  });

  /* ── QUANTITY CONTROL ────────────────────────────────────────── */
  document.querySelectorAll('.qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.closest('.qty-wrap').querySelector('.qty-input');
      if (!input) return;
      var val = parseInt(input.value) || 1;
      if (btn.dataset.dir === 'up')   input.value = val + 1;
      if (btn.dataset.dir === 'down') input.value = Math.max(1, val - 1);
    });
  });

  /* ── SMOOTH SCROLL (anchor links) ─────────────────────────────── */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.querySelector(a.getAttribute('href'));
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });

  /* ── NOTIFICATION TOAST ──────────────────────────────────────── */
  window.showToast = function (msg, type) {
    var t = document.createElement('div');
    t.className = 'toast toast--' + (type || 'success');
    t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function () { t.classList.add('toast--visible'); }, 10);
    setTimeout(function () { t.classList.remove('toast--visible'); setTimeout(function () { t.remove(); }, 400); }, 3500);
  };

})();
